import { App, Plugin } from 'vue';


const GlobalsPlugin: Plugin = {
	install: (app: App<Element>): void => {
		const rollbarConfig = {
			accessToken: '131a125886494ce681f6e9b6d5f38744',
			captureUncaught: false,
			captureUnhandledRejections: false,
			payload: {
				environment: CONFIG.STAGE,
			},
			checkIgnore: window["rollbarIgnore"],
		};

		const rollbar = (window && window["rollbar"] && window["rollbarIgnore"]) ? new window["rollbar"](rollbarConfig) : null;

		app.config.errorHandler = (error: any): void => {
			if (rollbar === null) {
				return;
			}

			if (CONFIG.STAGE === 'prd') {
				rollbar.error(error);
			}

			throw error;
		};
	},
};

export { GlobalsPlugin };
